import React, { useEffect, useState } from 'react';
import { CustomDesigner } from "../../Screens/DesignerUI";
import DesignerContainer
  from "@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/Designer";
import { makeStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { withCanvasState, withCanvas } from 'redhotmagma-graphics-editor/CanvasInterface/CanvasProvider';
import clsx from 'clsx';
import { alignObjectToArea, getFreePositions, rescaleObject, setObjectPosition } from '../../Helpers/canvasFunctions';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    pointerEvents: 'none',
    zIndex: -1,
    '& svg': {
      transition: 'fill .5s ease-in-out'
    }
  },
  area: {
    flex: 1,
    '& + $area': {
      borderTop: '1px dashed black',
    },
    justifyContent: 'space-around',
    display: 'flex',
    alignItems: 'center',
  },
  center: {
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    justifyContent: 'space-around',
    display: 'flex',
    alignItems: 'center'
  },
  blockedArea: {
    '& > *': {
      display: 'none',
    },
  },
  currentArea: {
    '& svg': {
      fill: '#616161',
    },
  }
});

const getCurrentArea = (selectedObject, size) => {
  const topMax = size.height * 0.375;
  const bottomMax = size.height * 0.625;
  let activeArea;
  if (selectedObject) {
    if (selectedObject.y <= topMax) {
      activeArea = 'top';
    } else if (selectedObject.y >= bottomMax) {
      activeArea = 'bottom';
    } else {
      activeArea = 'center'
    }
  }
  return activeArea;
}

const DesignerAreas = withCanvas(withCanvasState(({ canvas, selectedObject: selectedObjectState }) => {
  const classes = useStyles();
  const { selectedObject, size } = canvas;

  const currentArea = getCurrentArea(selectedObject, size);

  const grabbed = selectedObject ? selectedObject.grabbed : false;
  const activeAction = selectedObject ? selectedObject.activeAction : '';
  const content = selectedObject && selectedObject.content;

  const { x, y, rotation, scaling } = selectedObjectState || {};

  useEffect(() => {
    selectedObject && !activeAction && !grabbed && rescaleObject(selectedObject, size);
  }, [activeAction, selectedObject, grabbed, content]);

  useEffect(() => {
    // align object to the closest area center
    if (selectedObject && !grabbed && !activeAction) {
      if (selectedObject.userData.position !== currentArea) {
        setObjectPosition(selectedObject, currentArea, canvas.objects, size);
      }
      alignObjectToArea(selectedObject, size);
      rescaleObject(selectedObject, size);
    }
  }, [selectedObject, grabbed, activeAction, currentArea, size, x, y, rotation, scaling]);

  const freePositions = getFreePositions(canvas.objects);

  const createClassName = (targetArea) => (
    (grabbed && currentArea === targetArea && classes.currentArea)
    || (freePositions.indexOf(targetArea) === -1 && classes.blockedArea)
  );

  return (
    <div className={classes.root}>
      <div className={clsx(classes.center, createClassName('center'))}>
        <AddCircleOutlineIcon color="inherit"/>
      </div>
      <div className={clsx(classes.area, createClassName('top'))}>
        <AddCircleOutlineIcon color="inherit"/>
      </div>
      <div className={clsx(classes.area, createClassName('bottom'))}>
        <AddCircleOutlineIcon color="inherit"/>
      </div>
    </div>
  );
}));

export default (props) => (
  <DesignerContainer
    {...props}
    Component={CustomDesigner}
    renderInCanvasContainer={() => <DesignerAreas />}
  />
);
